export enum ListDisplayType {
    Generic = 0,
    ScrollTable = 1,
    Scroller = 2,
    ScrollPanel = 3,
    Card = 4
  }